import {FC} from "react";

interface IProps {
  title: string;
  value: string;
}

export const StatusBlock: FC<IProps> = ({title, value}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        color: "#ffffff",
      }}
    >
      <div>{title}</div>
      <div>{value}</div>
    </div>
  );
};
